import React, { Component } from 'react'
import Classes from './style.module.css'
export default class Thousandthree extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defVal: [],
            value: [],
            isUpdating: false,
            selectallchecked:true
        }
        this.storeValue = this.storeValue.bind(this)
    }
    componentDidMount() {
        const getValues = (data) => {
            console.log(data)
            var values = data
            if(values.includes(',')){
                if (values.indexOf(',') > -1) {
                    var arr = values.split(',')
                    return arr
                }
            }else{
                var arr = []
                arr.push(values)
                console.log(arr)
                return arr
            }
        }
        const getDefaultValuesArr = (data) => {
            var values = data
            if(values.includes(',')){
                if (values.indexOf(',') > -1) {
                    var arr = values.split(',')
                    return arr
                }
            }else{
                var arr = []
                arr.push(values)
                console.log(arr)
                return arr
            }
        }
        var value = getValues(this.props.filterData)
        var defVal =getDefaultValuesArr(this.props.defdata)
        value.map((val, index) => {
            var check = false
            if (defVal != undefined) {
                for (let i = 0; i < defVal.length; i++) {
                    if (defVal[i] == val) {
                        check = true
                        break
                    }
                }
                if(check == false){
                    this.setState({selectallchecked:false})
                }
            }
        })
        this.setState({
            defVal: defVal,
            value: value
        },() => {
            this.setState({isUpdationDone:true})
        })
    }
    componentDidUpdate(prevProps) {
        console.log(this.props.lastChange)
        if(document.getElementById(this.props.lastChange) != null && document.getElementById(this.props.lastChange) !=undefined){
            document.getElementById(this.props.lastChange).scrollIntoView({block:'center',behavior: 'smooth'});
        }
        if (prevProps.filterData != this.props.filterData || prevProps.defdata != this.props.defdata) {
            this.setState({isUpdationDone:false,selectallchecked:true})
            const getValues = (data) => {
                console.log(data)
                var values = data
                if(values.includes(',')){
                    if (values.indexOf(',') > -1) {
                        var arr = values.split(',')
                        return arr
                    }
                }else{
                    var arr = []
                    arr.push(values)
                    console.log(arr)
                    return arr
                }
            }
            const getDefaultValuesArr = (data) => {
                var values = data
                if(values.includes(',')){
                    if (values.indexOf(',') > -1) {
                        var arr = values.split(',')
                        return arr
                    }
                }else{
                    var arr = []
                    arr.push(values)
                    console.log(arr)
                    return arr
                }
            }
            var value = getValues(this.props.filterData)
            var defVal =getDefaultValuesArr(this.props.defdata)
            value.map((val, index) => {
                var check = false
                if (defVal != undefined) {
                    for (let i = 0; i < defVal.length; i++) {
                        if (defVal[i] == val) {
                            check = true
                            break
                        }
                    }
                    if(check == false){
                        this.setState({selectallchecked:false})
                    }
                }
            })
            this.setState({
                defVal: getDefaultValuesArr(this.props.defdata),
                value: getValues(this.props.filterData)
            },() => {
                this.setState({isUpdationDone:true})
            })
        }
    }
    storeValue(e) {
        var arr = []
        if (this.state.defVal != undefined && this.state.defVal[0] != '') {
            arr = this.state.defVal
        }
        if (e.target.checked == true) {
            arr.push(e.target.value)
            this.props.onChange(arr.join(','),e.target.value)
        } else {
            arr.splice(arr.indexOf(e.target.value), 1)
            this.props.onChange(arr.join(','),e.target.value)
        }
    }
    selectallclick(e) {
        this.setState({selectallchecked:!this.state.selectallchecked})
        if(e.target.checked == false){
            this.props.onChange('',e.target.value)
        }else{
            var arr =[]
            arr = this.state.value
            this.props.onChange(arr.join(','),e.target.value)
        }
    }
    render() {
        return (
            <>
                {
                    this.state.isUpdationDone ?
                        <div className={'row ' + Classes.overflow} style={{ maxHeight: "370px", overflow: "auto" }}>
                            <div className="col-md-6" style={{ display: 'flex', alignItems: "center", marginBottom: "5px" }}></div>
                            <div className="col-md-6" style={{ display: 'flex', alignItems: "center", marginBottom: "5px",justifyContent: 'flex-end'}}>
                                <input type="checkbox" id={'selectall'} value={'selectall'} name={'selectall'} checked={this.state.selectallchecked} onChange={(e) => this.selectallclick(e)} style={{ width: "20px", height: "20px" }} />
                                <label htmlFor={'selectall'} style={{ paddingLeft: "10px", cursor: "pointer" }}>Select All</label>
                            </div>
                            <hr style={{color: 'grey'}}></hr>
                            {
                                this.state.value.map((val, index) => {
                                    var check = false
                                    if (this.state.defVal != undefined) {
                                        for (let i = 0; i < this.state.defVal.length; i++) {
                                            if (this.state.defVal[i] == val) {
                                                check = true
                                                break
                                            }
                                        }
                                    }
                                    return (
                                        <>
                                            <div className="col-md-6" key={index} style={{ display: 'flex', alignItems: "center", marginBottom: "5px" }}>
                                                <input type="checkbox" id={val} value={val} name={val} defaultChecked={check} onChange={(e) => this.storeValue(e)} style={{ width: "20px", height: "20px" }} />
                                                <label htmlFor={val} style={{ paddingLeft: "10px", cursor: "pointer" }}>{val}</label>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                        :
                        "loading"
                }
            </>
        )
    }
}
